import { camelCase, lowerCase, snakeCase, toUpper, upperFirst } from 'lodash';
import { CamelCase, ScreamingSnakeCase } from 'type-fest';

export const convertCamelCaseToScreamingSnakeCase = <TCamelCase extends string>(
  val: TCamelCase,
): ScreamingSnakeCase<TCamelCase> => toUpper(snakeCase(val)) as ScreamingSnakeCase<TCamelCase>;

export const convertScreamingSnakeCaseToCamelCase = <TScreamingSnakeCase extends string>(
  val: TScreamingSnakeCase,
): CamelCase<TScreamingSnakeCase> => camelCase(val) as CamelCase<TScreamingSnakeCase>;

// E.g. "WonkyDonkey" -> "Wonky donkey"
export const convertPascalCaseToSentenceCase = (val: string): string => upperFirst(lowerCase(val));

// A name turned into the upper-snake key format used for ids a user types elsewhere — a team's
// specialist role key, a servicer profile's id. Anything that isn't a letter, digit or space is
// dropped rather than transliterated, so the result is always safe to retype by hand.
export const convertNameToKey = (name: string): string =>
  name
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^A-Z0-9_]/g, '');
